import { Error } from '../Error'
import { Width } from '../Width'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

import type { EmailField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

type EmailProps = EmailField & {
  errors: Partial<FieldErrorsImpl>
  register: UseFormRegister<FieldValues>
  placeholder?: string
  disabled?: boolean
}

export const Email: React.FC<EmailProps> = ({
  name,
  defaultValue,
  errors,
  label,
  register,
  required,
  placeholder,
  disabled,
}) => {
  return (
    <Width>
      <Label htmlFor={name}>
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Input
        defaultValue={defaultValue}
        id={name}
        type="email"
        placeholder={placeholder}
        disabled={disabled}
        {...register(name, { pattern: /^\S[^\s@]*@\S+$/, required })}
      />

      {errors[name] && <Error name={name} />}
    </Width>
  )
}
